module.exports = __webpack_public_path__ + "static/media/icon-login-facebook.98ea7702.svg";